export const SET_VALIDATOR_USED = "SET_VALIDATOR_USED";

